import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EntityCreateInput, StaffCreateEntityContainerEntityCreateDocument, StaffEntitySearchContainerEntitySearchDocument } from '../../../../generated.tsx';
import { lookupCountryQuery } from './staff-components-country-query.tsx'
import { Country } from '../../../../types/country.ts';
import { ComponentQueryLoader } from '../../../shared/component-query-loader.tsx';
import { EntityCreate } from './entity-create.tsx';

interface EntityCreateContainerProps {}

export const EntityCreateContainer: React.FC<EntityCreateContainerProps> = () => {
  const [newlyAddedEntityName, setNewlyAddedEntityName] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const [createEntity] = useMutation(StaffCreateEntityContainerEntityCreateDocument);
  const { data: countryData, loading: countryListLoading, error: countryListError } = useQuery(lookupCountryQuery);

  const [_pollForNewlyAddedEntity, { data: pollForNewlyAddedEntityData, startPolling: startPollingForNewlyAddedEntity, stopPolling: stopPollingForNewlyAddedEntity }] =
    useLazyQuery(StaffEntitySearchContainerEntitySearchDocument, { fetchPolicy: 'network-only' });

  useEffect(() => {
    if (pollForNewlyAddedEntityData?.entitySearch?.entityResults) {
      const isNewEntityFound = pollForNewlyAddedEntityData.entitySearch.entityResults.some((entity) => entity?.entityName === newlyAddedEntityName);
      if (isNewEntityFound) {
        stopPollingForNewlyAddedEntity();
        setIsProcessing(false);
        message.success('Entity created successfully.');
        navigate(-1);
      }
    }
  }, [pollForNewlyAddedEntityData]);

  const onSubmit = async (payload: EntityCreateInput) => {
    try {
      setNewlyAddedEntityName(payload.entityName);
      setIsProcessing(true);
      const response = await createEntity({
        variables: {
          input: payload
        }
      });

      if (response?.data?.entityCreate?.status?.success) {
        startPollingForNewlyAddedEntity(500);
      } else {
        setNewlyAddedEntityName('');
        message.error('Failed to create the entity: ' + response?.data?.entityCreate?.status?.errorMessage);
        setIsProcessing(false);
      }
    } catch (err: any) {
      setNewlyAddedEntityName('');
      message.error('Failed to create the entity: ' + err.message);
      setIsProcessing(false);
    }
  };

  return (
    <ComponentQueryLoader
      loading={countryListLoading}
      hasData={countryData}
      error={countryListError}
      hasDataComponent={<EntityCreate onSubmit={onSubmit} loading={isProcessing} countryData={countryData?.countries?.eventPayload?.countries as Country[]} />}
    />
  );
};
